import(/* webpackMode: "eager" */ "/app/src/app/privacy/page.tsx");
